import { jsx as _jsx } from "react/jsx-runtime";
import { ABContext } from '@as-react/common-components';
export const WrapWithABContext = (BaseComponent, { abConfigurationValue }) => function ABContextWrapper(props) {
    return (_jsx(ABContext.Provider, { value: abConfigurationValue, children: _jsx(BaseComponent, { ...props }) }));
};
